import { filterGoalsByFilterOptions, getWeekStartsOn } from '@griply/utils';
import { useGoals } from 'features/goals';
import { useFilterDocumentFilters } from 'features/tasks';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { getGoalsDeadlineEvents } from 'shared/lib/full-calendar';

import { useUpcomingFilterDocument } from './use-upcoming-filter-document';

export const useGoalDeadlineEvents = () => {
  const goals = useGoals();
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);

  // The calendar supplies its own date window, so the `or` branches are dropped here too.
  const upcomingFilterDocument = useUpcomingFilterDocument();
  const filterDocument = useMemo(
    () => ({ ...upcomingFilterDocument, or: null }),
    [upcomingFilterDocument],
  );
  const filters = useFilterDocumentFilters(filterDocument, {});

  const filteredGoals = useMemo(
    () => filterGoalsByFilterOptions(goals, filters),
    [goals, filters],
  );

  return useMemo(
    () => getGoalsDeadlineEvents(filteredGoals, weekStartsOn),
    [filteredGoals, weekStartsOn],
  );
};
